import axios from "./AxiosClient";
import { Constants } from "@socialcoach/services";
import { scCatchServiceException } from "../../annotations";
import { AasmEventLog } from "./dtos";

const VIDEO_PROJECTS_SERVICE = `${Constants.API_URL}/bedrock/video_projects`;

export class AasmEventLogServices {
  @scCatchServiceException()
  static async index(videoProjectId: string | number): Promise<AasmEventLog[]> {
    const { data } = await axios.get(`${VIDEO_PROJECTS_SERVICE}/${videoProjectId}/aasm_event_logs`);
    return data;
  }
}
